 <app-table-title [fontSize]="'24px'" [title]="'CONTACT_US' | dictionary"></app-table-title>
 <div class="m-portlet m-portlet--unair contacts-wrapper">
   <div class="d-flex flex-column contacts-block" *ngIf="contacts">
     <span class="contacts-sub">{{'DIRECT_INQUIRIES_TO' | dictionary}}:</span>
     <div class="d-flex flex-row contacts-item"
          *ngIf="contacts.WpContactAddress1 || contacts.WpContactAddress2 || contacts.WpContactAddress3 || contacts.WpContactAddress4">

       <i class="fas fa-envelope-square icon contacts-icon"></i>

       <div class="d-flex flex-column">
         <span>{{contacts.WpContactAddress1}}</span>
         <span>{{contacts.WpContactAddress2}}</span>
         <span>{{contacts.WpContactAddress3}}</span>
         <span>{{contacts.WpContactAddress4}}</span>
       </div>
     </div>

     <div class="d-flex flex-row contacts-item">
       <i class="fas fa-phone-square  icon contacts-icon"></i>
       <div class="d-flex flex-column">
         <a *ngIf="contacts.WpContactPhone" href="tel:{{contacts.WpContactPhone}}">{{contacts.WpContactPhone}}</a>
         <span><span class="text-uppercase">{{'FAX' | dictionary}}:</span> {{contacts.WpContactFax}}</span>
       </div>
     </div>
     <div class="d-flex flex-row contacts-item">
       <i class="fas fa-question-circle icon contacts-icon"></i>
       <div class="space-div"></div>

       <div *ngIf="this.clientCode != 'GPB'" class="d-flex flex-column">
         <a *ngIf="contacts.WpContactEmail" href="mailto:{{contacts.WpContactEmail}}">{{contacts.WpContactEmail}}</a>

         <span *ngIf="contacts.WpCompanyPhone" >{{'INQUIRIES_OTHER_ISSUES' | dictionary}}
               <a href="tel:{{contacts.WpCompanyPhone}}">{{contacts.WpCompanyPhone}}</a>

               <span *ngIf="contacts.WpIrEmail" > {{'OR_EMAIL' | dictionary}}: </span>
               <span *ngIf="!contacts.WpIrEmail" > {{'OR_VISIT' | dictionary}}: </span>
               <a *ngIf="contacts.WpIrEmail" href="mailto:{{contacts.WpIrEmail}}">{{contacts.WpIrEmail}}</a>
               <a *ngIf="!contacts.WpIrEmail" target="_blank" [href]="'//' + contacts.WpCompanyWebsite">{{contacts.WpCompanyWebsite}} </a>
             </span>
       </div>

       <div *ngIf="this.clientCode === 'GPB'" class="d-flex flex-column">
         <a *ngIf="contacts.WpContactEmail" href="mailto:{{contacts.WpContactEmail}}">{{contacts.WpContactEmail}}</a>

         <span *ngIf="contacts.WpCompanyPhone" >{{'INQUIRIES_OTHER_ISSUES_GPB' | dictionary}}
               <a  href="mailto:{{contacts.WpCompanyEmail}}">{{contacts.WpCompanyEmail}}</a>

               <span> {{'OR_VISIT_GPB' | dictionary}} </span>
               <a  target="_blank" [href]="'//' + contacts.WpCompanyWebsite">{{contacts.WpCompanyWebsite}}</a>
             </span>
       </div>
     </div>
   </div>
 </div>




